module.exports = __webpack_public_path__ + "assets/images/dffd234bb8d38435836ed50a565cbd1a.png";